



























import TableComp from '@/components/Common/TableComp.vue';
import { Component, Prop, Vue, Watch, ModelSync } from 'vue-property-decorator';
import {
  getIssueUserSubordinateApi,
} from '@/api/company';

@Component({
  name: 'subordinateListDialog',
  components: {
    TableComp,
  }
})
export default class extends Vue {
  @Prop() public row!: any;
  @ModelSync('dialogVisible', 'changeVisible', { type: Boolean }) public dialogTableVisible!: boolean;

  public tableData: any[] = [];

  @Watch('dialogTableVisible')
  public watchVisible(visible: boolean) {
    if (visible) {
      this.getIssueUserSubordinate();
    }
  }

  public async getIssueUserSubordinate() {
    const { data } = await getIssueUserSubordinateApi(this.row.id);
    this.tableData = data.datas;
  }
}
